import { useParams } from "react-router-dom";
import { useStore } from "../store";
import {
  getEmptyTabDisplayName,
  resolveTabDataFromStore,
  shouldShowEmptyTabWarning,
} from "../utils/emptyTabWarning";

export function usePublishedEmptyTabWarning({
  tabKey,
  fallbackName,
  data,
  loaded = true,
} = {}) {
  const { micrositeId } = useParams();
  const { tabData, microSites } = useStore();

  const currentMicrosite = Array.isArray(microSites)
    ? microSites.find((site) => site.id === micrositeId)
    : null;

  const resolvedData =
    data !== undefined ? data : resolveTabDataFromStore(tabData, tabKey);

  return {
    show:
      loaded &&
      shouldShowEmptyTabWarning({
        isPublished: Boolean(currentMicrosite?.isPublished),
        status: 200,
        data: resolvedData,
      }),
    tabName: getEmptyTabDisplayName(tabKey, fallbackName),
  };
}
